import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

export default class TeamsActiveTeamsTableIndexComponent extends Component {
  @service intl;

  @tracked columns = this.args?.columns ?? [
    {
      name: this.intl.t('_teams.name'),
      valuePath: 'name',
      class: '!w-[80%]',
      key: 'name',
      component: 'teams/active-teams/table-cell/title',
      test_id: 'team-name',
      isSortable: false,
    },
    {
      name: this.intl.t('_teams.capacity-fte'),
      valuePath: 'ftes',
      class: '!w-[10%] header-center',
      key: 'ftes',
    },
    {
      name: this.intl.t('_teams.members', {
        num: 2,
      }),
      component: 'link',
      valuePath: 'people',
      class: '!w-[10%] header-center capitalize',
      key: 'people',
      isSortable: false,
    },
  ];

  convertTeamItemToRow(item) {
    return {
      name: item,
      people: {
        label: item.activeMembers.length,
        route: 'resources.people.active',
        query: { breakout: 'team' },
      },
      ftes: item.ftes?.toFixed(2),
    };
  }

  get rows() {
    if (this.args?.rows) return this.args.rows;
    return this.args?.teams.map((item) => this.convertTeamItemToRow(item));
  }
}
